<template>
  <div
    style="width: 100vw; height: 100vh"
    :class="`bg-${statusBackground}`"
    class="bg-lighten-4"
  >
    <div
      style="max-width: 800px; height: 100vh"
      class="mx-auto d-flex flex-column justify-content-center align-items-center border shadow bg-light"
    >
      <b-img
        style="height: 150px"
        :src="require('@/assets/images/logo/header-logo.png')"
        alt="logo"
      />
      <feather-icon
        class="mt-5 mb-2"
        :icon="statusIcon"
        :class="`text-${statusBackground}`"
        size="80"
      />
      <h2 class="mb-5" :class="`text-${statusBackground}`">{{ statusText }}</h2>
      <router-link to="/">
        <b-button variant="primary">عودة للرئيسية</b-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { BImg, BButton } from "bootstrap-vue";
export default {
  components: {
    BImg,
    BButton,
  },
  computed: {
    statusBackground() {
      return this.$route.query.s === "C"
        ? "secondary"
        : this.$route.query.s === "A"
        ? "success"
        : this.$route.query.s === "P"
        ? "warning"
        : "danger";
    },
    statusIcon() {
      return this.$route.query.s === "C"
        ? "AlertCircleIcon"
        : this.$route.query.s === "A"
        ? "CheckCircleIcon"
        : this.$route.query.s === "P"
        ? "ClockIcon"
        : "XCircleIcon";
    },
    statusText() {
      return this.$route.query.s === "C"
        ? "تم إلغاء عملية التبرع"
        : this.$route.query.s === "A"
        ? "تمت عملية التبرع بنجاح"
        : this.$route.query.s === "P"
        ? "طلبكم قيد المعالجة ..."
        : "حدث خطأ في عملية التبرع لدى بوابة الدفع الإلكتروني";
    },
  },
};
</script>
